<template>
    <div>
        <div class="row form-group">
            <div class="col-12">
                <hr />
            </div>
        </div>
        
        <div class="row form-group">
            <div class="col-12">
                <label>{{resource('JourneyBuilder_TimerSettings_Duration')}}</label>
            </div>
        </div>
    
        <div class="row form-group">
            <div class="col-6">
                <settings-property>
                    <template #label="{id}">
                        <label :for="id">{{resource('JourneyBuilder_TimerSettings_Duration_StartDate_Label')}}</label>
                    </template>
                    <template #input="{id}">
                        <date-picker v-model="startDateModel"
                                     :options="{
                                        disabled: !canWrite, 
                                        typeable: false,
                                        id: id 
                                    }"
                        />
                    </template>
                    <template #errors>
                        <required-error-message v-if="$v.$dirty && $v.startDate.$invalid" />
                    </template>
                </settings-property>
            </div>
    
            <div class="col-6">
                <settings-property>
                    <template #label="{ id }">
                        <label :for="id">{{resource('JourneyBuilder_TimerSettings_Duration_EndDate_Label')}}</label>
                    </template>
                    <template #input="{ id }">
                        <date-picker v-model="endDateModel"
                                     :options="{ 
                                        disabled: !canWrite || isPerpetualModel, 
                                        typeable: false,
                                        disabledDates: {
                                            to: startDateModel
                                        },
                                        id: id
                                     }"
                        />
                    </template>
                    <template #errors>
                        <required-error-message v-if="$v.$dirty && $v.endDate.$invalid" />
                    </template>
                </settings-property>
            </div>
        </div>
    
        <div class="row form-group">
            <div class="col-6 offset-6">
                <input
                    v-model="isPerpetualModel"
                    type="checkbox"
                    id="is-perpetual"
                    
                    :disabled="!canWrite"
                >
    
                <label for="is-perpetual">{{resource('JourneyBuilder_TimerSettings_Duration_IsPerpetual_Label')}}</label>
            </div>
        </div>
    </div>
</template>

<script>
import { timerDurationValidations } from './validations';
import dateHelpers from '@modules/JourneyBuilder/Util/date-helpers';

import { validationMixin } from 'vuelidate';
import permissionsMixin from "@modules/JourneyBuilder/Mixins/journey-permissions";
import resourceMixin from "@core/Util/Mixins/resources";

import SettingsProperty from "../SettingsProperty";
import DatePicker from "@core/Components/Util/DatePicker";
import RequiredErrorMessage from "@core/Components/Errors/RequiredErrorMessage";

export default {
    name: "BrickTimerDurationSettings",
    
    mixins: [validationMixin, permissionsMixin, resourceMixin],
    
    components: {
        SettingsProperty,
        DatePicker,
        RequiredErrorMessage
    },

    props: {
        startDate: {
            type: String,
            required: false
        },

        endDate: {
            type: String,
            required: false
        },

        isPerpetual: {
            type: Boolean,
            required: false
        }
    },

    computed: {
        startDateModel: {
            get() {
                return this.startDate && dateHelpers.getDateFromString(this.startDate);
            },
            set(value) {
                this.$emit('update:startDate', value && dateHelpers.getStringifiedDate(value))
            }
        },

        endDateModel: {
            get() {
                return this.endDate && dateHelpers.getDateFromString(this.endDate);
            },
            set(value) {
                this.$emit('update:endDate', value && dateHelpers.getStringifiedDate(value))
            }
        },

        isPerpetualModel: {
            get() {
                return this.isPerpetual;
            },
            set(value) {
                this.$emit('update:isPerpetual', value)
            }
        }
    },
    
    validations: timerDurationValidations,
    
    watch: {
        isPerpetualModel() {
            //Reset enddate - it was either already empty or contains a now invalid value
            this.$emit('update:endDate', undefined);
        },

        startDateModel(value) {
            if(!value || !this.endDateModel) {
                return;
            }
            
            const endDate = dateHelpers.getDateFromString(this.endDateModel);
            const startDate = dateHelpers.getDateFromString(value);
            
            //Clear our enddate when our startdate gets set to after our enddate
            if(startDate > endDate) {
                this.$emit('update:endDate', undefined);
            }
        }
    },

    methods: {
        displayErrors() {
            this.$v.$touch();
        }
    }
}
</script>
